import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-farah",
  "use": "icon-farah-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-farah\">\n  <defs>\n    <style>\n      #icon-farah .cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M6.66,11l3.34-.67,1-1.67,1-1.67,2,3.34,3.34.67-2.67,2.67.67,3.34-3.34-1.67-3.34,1.67.67-3.34-2.67-2.67Z\" />\n  <circle class=\"cls-1\" cx=\"12\" cy=\"12\" r=\"9.59\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol